import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

import get from "lodash.get"
import dayjs from "dayjs"

const header = [
	[
		"Template A4 - Number of policies expired, by four Underwriting/ Re-underwriting results, by age and sex of contractInsured Person"
	],
	["Age", "Sex", "Standard Plan", "", "", "", "Flexi Plan"],
	[
		"",
		"",
		"Standard Offer",
		"Offer with Premium Loading Only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Standard Offer",
		"With Premium Loading only",
		"With CBE only",
		"With Premium Loading and CBE"
	]
]

// Return calculated age
const getAge = item => {
	const dateOfBirth = item?.insureds?.[0]?.dateOfBirth
	const currentYear = dayjs().year()
	const yearOfBirth = dayjs(dateOfBirth).year()
	return currentYear - yearOfBirth
}

const rows = payload => {
	let output = []
	for (let i = 1; i < 100; i++) {
		output.push([
			i,
			"M",
			countExpiredStandardOffer(i, "male", payload, "S00027"),
			countExpiredOfferWithLoadings(i, "male", payload, "S00027"),
			countExpiredOfferWithExclusions(i, "male", payload, "S00027"),
			countExpiredOfferWithLoadingsAndExclusions(i, "male", payload, "S00027"),
			countExpiredStandardOffer(i, "male", payload, "F00038"),
			countExpiredOfferWithLoadings(i, "male", payload, "F00038"),
			countExpiredOfferWithExclusions(i, "male", payload, "F00038"),
			countExpiredOfferWithLoadingsAndExclusions(i, "male", payload, "F00038")
		])
	}
	for (let j = 1; j < 100; j++) {
		output.push([
			j,
			"F",
			countExpiredStandardOffer(j, "female", payload, "S00027"),
			countExpiredOfferWithLoadings(j, "female", payload, "S00027"),
			countExpiredOfferWithExclusions(j, "female", payload, "S00027"),
			countExpiredOfferWithLoadingsAndExclusions(
				j,
				"female",
				payload,
				"S00027"
			),
			countExpiredStandardOffer(j, "female", payload, "F00038"),
			countExpiredOfferWithLoadings(j, "female", payload, "F00038"),
			countExpiredOfferWithExclusions(j, "female", payload, "F00038"),
			countExpiredOfferWithLoadingsAndExclusions(j, "female", payload, "F00038")
		])
	}
	return output
}

const countExpiredStandardOffer = (age, gender, payload, plan) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = policy?.contractInsured?.[0]?.gender
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredAge === age &&
			insuredGender === gender &&
			matchPlan &&
			dayjs().isAfter(policy?.endDate) === true
		) {
			return policy
		}
	}).length
}

const countExpiredOfferWithLoadings = (age, gender, payload, plan) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = policy?.contractInsured?.[0]?.gender
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredAge === age &&
			insuredGender === gender &&
			loadings === true &&
			exclusions === false &&
			matchPlan &&
			dayjs().isAfter(policy?.endDate) === true
		) {
			return policy
		}
	}).length
}

const countExpiredOfferWithExclusions = (age, gender, payload, plan) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = policy?.contractInsured?.[0]?.gender
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredAge === age &&
			insuredGender === gender &&
			exclusions === true &&
			loadings === false &&
			matchPlan &&
			dayjs().isAfter(policy?.endDate) === true
		) {
			return policy
		}
	}).length
}

const countExpiredOfferWithLoadingsAndExclusions = (
	age,
	gender,
	payload,
	plan
) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = policy?.contractInsured?.[0]?.gender
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredAge === age &&
			insuredGender === gender &&
			loadings &&
			exclusions &&
			matchPlan &&
			dayjs().isAfter(policy?.endDate) === true
		) {
			return policy
		}
	}).length
}

const fetchData = async filterPayload => {
	const query = gql`
		query fetchTemplateA4Payload($policyWhere: policyWhereInput) {
			policies(where: $policyWhere) {
				list {
					status
					product {
						productId {
							plan
						}
					}
					endDate
					contractInsured {
						... on individual {
							gender
							dateOfBirth
						}
					}
					premium {
						loadings {
							id
						}
					}
					exclusions {
						id
					}
				}
			}
		}
	`
	const variables = {
		policyWhere: filterPayload
	}

	const res = await api({ query, variables })

	return res?.data?.policies?.list
}

export default async filterPayload => {
	const fetchedData = await fetchData(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 2, c: 1 }
		},
		{
			s: { r: 1, c: 2 },
			e: { r: 1, c: 5 }
		},
		{
			s: { r: 1, c: 6 },
			e: { r: 1, c: 9 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}
